<template>
  <ActionMenu class="custom-list-doc">
    <Action
      class="custom-list-doc__btn--remove"
      icon="idelete"
      @click.prevent="removeDocFromList(doc, docsView, list)"
    >
      Remove from List
    </Action>
  </ActionMenu>
</template>

<script setup lang="ts">
import type { CustomList, UserDocListItem } from '@/models/interfaces'
import { removeDocFromList } from '@/models/custom.lists'
import type { DocsView } from '@/models/doc'

import ActionMenu from '@/app/components/ActionMenu.vue'
import Action from '@/app/components/ActionMenuItem.vue'

defineProps<{
  doc: UserDocListItem
  docsView: DocsView
  list: CustomList
}>()
</script>

<style lang="scss" scoped>
.custom-list-doc {
  --button-background-hover: #{rgba($c-black-2, 0.05)};
}

.night-mode .custom-list-doc {
  --button-background-hover: #{rgba($c-dark-3, 0.5)};
}
</style>
